import React, { useEffect, useState } from 'react';

import Slider from 'react-slick';

import { IFormat } from '../../../../store/admin/roundFormats/store';

import Button from '../../../../components/Button';
import {
  TTeamFormatPrefix,
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { sortBy } from '../../../../contrib/sortBy';
import { useGetPlayerEvent } from '../../../../contrib/Hooks/useGetPlayerEvent';
import { iconsMap } from './Utils/iconsMap';
interface TTeamFormatOption {
  id: number;
  name: string;
  slug: TTeamFormatPrefix;
}

interface IProps {
  eventId: number;
  formatId: number | undefined;
  displayTeamFormats: boolean;
  roundId: number;
  holeIndex: number;
  onChangeFormat: () => void;
}

export const FormatOptions = (props: IProps) => {
  const { onChangeFormat, eventId, formatId, displayTeamFormats, roundId, holeIndex } = props;

  const { dispatch: dispatchAssignResults } = useAssignResultsDispatch();

  const { formatsList, selectedTeamFormat } = useAssignResultsState();

  const availableFormats = sortBy(Object.values(formatsList), 'asc', 'isContest');

  const event = useGetPlayerEvent(String(eventId));

  const [holeIsCTP, setHoleIsCTP] = useState(false);
  const [teamFormatsOptions, setTeamFormatsOptions] = useState<TTeamFormatOption[]>([]);

  useEffect(() => {
    if (event) {
      setHoleIsCTP(
        Object.values(event.formats).some(format =>
          format.format.prefix === 'ctp'
            ? !!holeIndex
              ? roundId &&
                format.metadata &&
                format.metadata[roundId] &&
                format.metadata[roundId].includes(Number(holeIndex))
              : true
            : true
        )
      );
    }
  }, [event, holeIndex, roundId]);

  const onChangeRegularFormat = (formatToSelectId: number) => async () => {
    onChangeFormat();

    dispatchAssignResults({
      type: 'selectFormat',
      value: formatToSelectId
    });
    dispatchAssignResults({
      type: 'selectTeamFormat',
      value: undefined
    });
  };

  const onChangeTeamFormat = (teamFormatToSelect: TTeamFormatPrefix) => () => {
    onChangeFormat();

    dispatchAssignResults({
      type: 'selectFormat',
      value: undefined
    });
    dispatchAssignResults({
      type: 'selectTeamFormat',
      value: teamFormatToSelect
    });
  };

  useEffect(() => {
    if (event) {
      const teamFormat = event.formats.find(frmt => frmt.format.prefix.includes('team'));

      if (teamFormat) {
        const options: TTeamFormatOption[] = [
          { id: 1, name: 'TEAMS TOTAL SCORE', slug: 'teamStrokeTotal' },
          { id: 2, name: 'TEAMS BEST BALL', slug: 'teamStrokeBetterball' }
        ];

        setTeamFormatsOptions(
          options.filter(option => teamFormat.aggregations.includes(option.id))
        );
      }
    }
  }, [event]);

  const showSlider =
    availableFormats.length >
    3 -
      (!!availableFormats.find(
        (availableFormat: IFormat) => availableFormat.prefix !== 'teamstroke'
      )
        ? 1
        : 0);

  const settings = showSlider
    ? {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3.3,
        speed: 300
      }
    : { className: 'container-component' };

  const ContainerComponent = showSlider ? Slider : 'div';

  return (
    <div className="format-options">
      <ContainerComponent {...settings}>
        {event &&
          displayTeamFormats &&
          teamFormatsOptions.map(option => {
            const isTeamFormatSelected = option.slug === selectedTeamFormat;

            return (
              <Button
                key={`team-format-option-${option.slug}`}
                color="primary"
                classes={{ label: 'list-filter__label' }}
                className={`list-filter override list-filter--${
                  isTeamFormatSelected ? '' : 'in'
                }active`}
                onClick={onChangeTeamFormat(option.slug)}
                variant={isTeamFormatSelected ? 'contained' : 'outlined'}
              >
                <div className="icon">
                  <img
                    src={iconsMap.stroke[isTeamFormatSelected ? 'selected' : 'notSelected']}
                    className="logo"
                    alt="logo"
                  />
                </div>
                {option.name}
              </Button>
            );
          })}

        {availableFormats &&
          availableFormats
            .filter((availableFormat: IFormat) =>
              availableFormat.prefix === 'ctp' ? holeIsCTP : availableFormat.prefix !== 'teamstroke'
            )
            .map((availableFormat: IFormat) => {
              const isFormatSelected = !selectedTeamFormat && availableFormat.id === formatId;

              const formatIconMap =
                iconsMap[availableFormat.prefix.replace('_', '') as keyof typeof iconsMap];

              return formatIconMap ? (
                <Button
                  key={availableFormat.id}
                  color="primary"
                  classes={{ label: 'list-filter__label' }}
                  className={`list-filter override ${
                    isFormatSelected ? 'list-filter--active' : 'list-filter--inactive'
                  }`}
                  onClick={onChangeRegularFormat(availableFormat.id)}
                  variant={isFormatSelected ? 'contained' : 'outlined'}
                >
                  <div className="icon">
                    <img
                      src={formatIconMap[isFormatSelected ? 'selected' : 'notSelected']}
                      className="logo"
                      alt="logo"
                    />
                  </div>
                  {availableFormat.name}
                </Button>
              ) : (
                <></>
              );
            })}
      </ContainerComponent>
    </div>
  );
};
